import React from 'react'
import { AiOutlineExclamationCircle } from 'react-icons/ai'
import { Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap'
import { CustomButton, SimpleTitleCard } from 'styles/global'

interface ModalExclusaoProps {
  isOpen: boolean
  toggle: (e: boolean) => void
  onRemove: () => void
  customMessage?: string
}

const ModalExclusao = ({
  isOpen,
  toggle,
  onRemove,
  customMessage
}: ModalExclusaoProps) => {
  return (
    <Modal isOpen={isOpen}>
      <ModalHeader toggle={() => toggle(!isOpen)}>
        <SimpleTitleCard colorIcon="F7931E">
          <AiOutlineExclamationCircle className="icon" />
          Atenção!
        </SimpleTitleCard>
      </ModalHeader>
      <ModalBody>
        <p>
          {customMessage
            ? customMessage
            : 'Deseja realmente inativar este registro?'}
        </p>
      </ModalBody>
      <ModalFooter>
        <Row className="d-flex column-gap-20">
          <CustomButton onClick={() => toggle(!isOpen)} background="#662D91">
            Cancelar
          </CustomButton>
          <CustomButton
            onClick={() => {
              onRemove()
              toggle(!isOpen)
            }}
          >
            Confirmar
          </CustomButton>
        </Row>
      </ModalFooter>
    </Modal>
  )
}

export default ModalExclusao
